export default __webpack_public_path__ + "static/media/spid-idp-posteid.683b0cb6.png";